import React, { useReducer } from 'react';
import { chatInitialState } from '../../../constants/chatbot';
import { Action, IChatState } from '../../../interfaces/chat.interface';
import { convertMarkdownToHTML } from '../../../utils/functions';
import ChatBox from '../../molecules/chat-box/ChatBox';
import './Chat.scss';

// @ts-ignore
import chatIcon from '../../../assets/icons/CDA/chat.svg';

const reducerFunctions = (state: IChatState, action: Action) => {
    switch (action.type) {
        case 'ADD_MESSAGE':
            return {
                ...state,
                chatData: [
                    ...state.chatData,
                    {
                        ...action.message,
                        message: convertMarkdownToHTML(action.message.message),
                    },
                ],
                chatDataMD: [...state.chatDataMD, action.message],
            };
        case 'VOTE_MESSAGE':
            return {
                ...state,
                chatData: state.chatData.map((message) =>
                    message.id === action.messageId
                        ? { ...message, vote: action.vote }
                        : message
                ),
            };
        case 'RESET_STATE':
            return { ...chatInitialState, sessionData: String(Date.now()) };
        case 'SET_STATE':
            return { ...state, ...action.newState };
        case 'TOGGLE_CHAT':
            return { ...state, showChat: !state.showChat };
        default:
            return state;
    }
};

const Chat = () => {
    const [chatState, setChatState] = useReducer(
        reducerFunctions,
        chatInitialState
    );

    return (
        <div className="o-chat">
            {chatState.showChat ? (
                <ChatBox chatState={chatState} setChatState={setChatState} />
            ) : (
                <button
                    className="chat__button"
                    onClick={() => setChatState({ type: 'TOGGLE_CHAT' })}
                    aria-label="Abrir chat"
                >
                    <img src={chatIcon} alt="chat icon" />
                    <span>Chatea con nuestra IA</span>
                </button>
            )}
        </div>
    );
};

export default Chat;
